import { Component, OnDestroy } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { Subscription } from 'rxjs/Subscription';

import { Restaurant } from './restaurant';

import { RestaurantService } from './restaurant.service';

import { MessageService }     from './message.service';

import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
  animations: [
    trigger('contact-form', [
            state('inactive', style({
                height: '0'
            })),
            state('active', style({
                height: '*'
            })),
            transition('inactive => active', animate('200ms ease-in')),
            transition('active => inactive', animate('200ms ease-out'))
        ])
  ]
})

export class ContactUsComponent implements OnDestroy {

  subscription : Subscription;

  constructor(
    private messageService: MessageService
    ) {
      console.log("BookComponent constructor")
      this.subscription = this.messageService.getScrollToContact().subscribe(message => { 
        console.log("ContactUsComponent received message");

        this.m_state = (this.m_state === 'inactive' ? 'active' : 'inactive');
      });
    }

  m_state: string = 'inactive';

  clickedShowHideContactForm() {
        this.m_state = (this.m_state === 'inactive' ? 'active' : 'inactive');
    }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/contact-us.component.ts